import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@altimateai/lego";
import { Tag } from "../types";
import { TagForm } from "./TagForm";

interface TagFormDialogProps {
  tag?: Tag;
  onClose?: () => void;
}

const TagFormDialog = ({ tag, onClose }: TagFormDialogProps) => {
  const isEditMode = !!tag;

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{isEditMode ? "Edit Tag" : "Create Tag"}</DialogTitle>
        </DialogHeader>
        <TagForm tag={tag} onCancel={onClose} onSubmit={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export default TagFormDialog;
